import { render, staticRenderFns } from "./SystemOptions.vue?vue&type=template&id=3b0ba548&scoped=true"
import script from "./SystemOptions.vue?vue&type=script&lang=js"
export * from "./SystemOptions.vue?vue&type=script&lang=js"
import style0 from "./SystemOptions.vue?vue&type=style&index=0&id=3b0ba548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ba548",
  null
  
)

export default component.exports